export default __webpack_public_path__ + "static/media/Animale_desktop_banner_1.4f57bfd5.png";